import React, { useContext, useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Nav from "react-bootstrap/Nav";
import { LoginContext } from "../context/LoginContext";
import useTheme from "./useTheme";

const Faq = () => {
  const [theme, switchTheme] = useTheme();

  const [faq, setFaq] = useState([]);

  const [showFaq, setShowFaq] = useState(false);

  const [showAdd, setShowAdd] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [showResultAdd, setShowResultAdd] = useState(false);

  const [showResultDelete, setShowResultDelete] = useState(false);

  const [question, setQuestion] = useState("");

  const [answer, setAnswer] = useState("");

  const [category, setCategory] = useState(1);

  const [alert, setAlert] = useState("");

  const [addResultMsg, setAddResultMsg] = useState("");

  const [deleteResultMsg, setDeleteResultMsg] = useState("");

  const [pkFaq, setPkFaq] = useState(0);

  const login = useContext(LoginContext);

  useEffect(() => {
    const formData = new FormData();
    formData.append("get_faq", 1);
    formData.append("category", 1);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.data !== null) {
          setFaq(data.data);
        } else {
          setFaq([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [addResultMsg, deleteResultMsg]);

  const addFaq = () => {
    if (question.length < 5 || answer.length < 5) {
      setAlert("لطفا سوال و جواب را کامل کنید");
      return;
    }
    const formData = new FormData();
    formData.append("set_faq", 1);
    formData.append("question", question);
    formData.append("answer", answer);
    formData.append("category", category);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setAddResultMsg(data.data);
        setShowResultAdd(true);
      })
      .catch((e) => {
        setAddResultMsg("مشکل در برقراری ارتباط با سرور");
        setShowResultAdd(true);
        console.log(e);
      });
  };

  const deleteFaq = () => {
    const formData = new FormData();
    formData.append("delete_faq", 1);
    formData.append("pk_faq", pkFaq);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setDeleteResultMsg(data.data);
        setShowResultDelete(true);
      })
      .catch((e) => {
        setDeleteResultMsg("مشکل در برقراری ارتباط با سرور");
        setShowResultDelete(true);
        console.log(e);
      });
  };

  const questionHandle = (e) => {
    setQuestion(e.target.value);
  };

  const categoryHandle = (e) => {
    setCategory(e.target.value);
  };

  const answerHandle = (e) => {
    setAnswer(e.target.value);
  };

  const closeAdd = () => {
    setShowResultAdd(false);
    setShowAdd(false);
    setAddResultMsg("");
    setQuestion("");
    setAnswer("");
    setAlert("");
  };

  const closeDelete = () => {
    setShowResultDelete(false);
    setShowDelete(false);
    setDeleteResultMsg("");
  };

  return (
    <div>
      <Nav.Link
        onClick={() => {
          setShowFaq(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        سوالات متداول
      </Nav.Link>
      <Modal
        show={showFaq}
        onHide={() => setShowFaq(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          سوالات متداول
        </Modal.Header>
        <Modal.Body className={theme === "light" ? "bg-light" : "bg-dark"}>
          {faq.length !== 0 ? (
            <Accordion defaultActiveKey="0">
              {faq.map((item, index) => (
                <Card key={index}>
                  <Accordion.Toggle as={Card.Header} eventKey={index}>
                    <div className="text-primary">{item.question}</div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index}>
                    <Card.Body>
                      {item.answer}
                      {login.loginState &&
                      login.userInfo.mobile === "09121245586" ? (
                        <div>
                          <button
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => {
                              setPkFaq(item.pkFaq);
                              setShowDelete(true);
                            }}
                          >
                            حذف
                          </button>
                        </div>
                      ) : null}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          ) : (
            <p className={theme === "light" ? "text-dark" : "text-light"}>
              سوالی برای نمایش یافت نشد
            </p>
          )}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button className="btn btn-dark" onClick={() => setShowFaq(false)}>
            بستن
          </button>
          {login.loginState && login.userInfo.mobile === "09121245586" ? (
            <button
              className="btn btn-success"
              onClick={() => setShowAdd(true)}
            >
              افزودن سوال
            </button>
          ) : null}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAdd}
        onHide={() => setShowAdd(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          افزودن سوال
        </Modal.Header>
        <Modal.Body className={theme === "light" ? "bg-light" : "bg-dark"}>
          <div className="row">
            <div className="col-12">
              <label
                className={
                  theme === "light"
                    ? "text-dark form-label"
                    : "text-light form-label"
                }
              >
                دسته بندی
              </label>
              <select
                className="form-control rtl"
                value={category}
                onChange={categoryHandle}
              >
                <option value={1}>همراه ویترین</option>
                <option value={2}>گروه 2</option>
                <option value={3}>گروه 3</option>
              </select>
            </div>
            <div className="col-12 mt-2">
              <label
                className={
                  theme === "light"
                    ? "text-dark form-label"
                    : "text-light form-label"
                }
              >
                متن سوال
              </label>
              <textarea
                className="form-control rtl"
                value={question}
                onChange={questionHandle}
              ></textarea>
            </div>
            <div className="col-12 mt-2">
              <label
                className={
                  theme === "light"
                    ? "text-dark form-label"
                    : "text-light form-label"
                }
              >
                متن جواب
              </label>
              <textarea
                className="form-control rtl"
                value={answer}
                onChange={answerHandle}
              ></textarea>
            </div>
            <div className="col-12 mt-2">
              <label className="text-danger">{alert}</label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button className="btn btn-dark" onClick={() => setShowAdd(false)}>
            بستن
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              addFaq();
            }}
          >
            افزودن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showResultAdd}
        onHide={() => {
          closeAdd();
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {addResultMsg}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              closeAdd();
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {"آیا از حذف سوال اطمینان دارید؟"}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-success"
            onClick={() => {
              deleteFaq();
            }}
          >
            بله
          </button>
          <button
            className="btn btn-danger"
            onClick={() => setShowDelete(false)}
          >
            خیر
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showResultDelete}
        onHide={() => {
          closeDelete();
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {deleteResultMsg}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              closeDelete();
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Faq;
